<template>
  <ArlaNavbar />

  <section class="hero do-good-page">
    <div class="hero-body">
      <div class="container" style="height: 100%;">
        <div class="columns" style="height: 100%;">
          <div class="column has-text-centered is-flex is-flex-direction-column">

            <h1 class="has-text-centered font-arla-strong-regular font-43 color-dg lh-49">
              KIITOS!
            </h1>

            <p class="has-text-centered arlainterface-regular font-16 mt-6">
              Olemme saaneet vastauksesi.
            </p>

            <div class="mt-auto">
              <div class="column is-12 has-text-centered">
                <button class="button arla-button dark-red-btn" @click="goArlaLuonto">Arla Aamu+</button>
              </div>
              <div class="column is-12 has-text-centered">
                <button class="button arla-button" @click="this.$router.push({ path: `/` });">Piirrä
                  lintukaveri!</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <ArlaFooter />
</template>

<script>
import ArlaNavbar from "../components/ArlaNavbar";
import ArlaFooter from "../components/ArlaFooter";

export default {
  name: "QuestionnairePage",
  components: {
    ArlaNavbar,
    ArlaFooter,
  },
  methods: {
    goArlaLuonto() {
      window.open("https://www.arla.fi/tuotteet/luontoplus/", "_blank");
    }
  }
}
</script>

<style scoped lang="scss">
@use "../assets/sass/mybulma" as *;

.do-good-page {
  flex: 1 1 auto;
}

.hero-body {
  background-color: #F6F1D3;
}
</style>